package org.example.project.engineletter.layouts.sys

import org.example.project.engineletter.layouts.SupportLayoutSysCustomDocumentContainer

import androidx.compose.runtime.Composable
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
fun SysTextToPdfWEQualitaetsdokumentationLayout(
    rootElementId: String? = null,
    auftrag: All,
    unternehmen: All,
    logoSrc: String,
    kontrollDefinitionen: List<All> = emptyList()
) {
    SupportLayoutSysCustomDocumentContainer(rootElementId = rootElementId) {
        WEVorgangslogPage {
            WEVorgangslogHeader(unternehmen = unternehmen, logoSrc = logoSrc)
            WEQualitaetsdokumentationTitleRow(auftrag = auftrag)
            WEVorgangslogPartyCards(auftrag)
            WEVorgangslogDivider()
            WEVorgangslogMeta(auftrag = auftrag)
            WEVorgangslogDivider()
            WEQualitaetsdokumentationTiles(auftrag = auftrag, kontrollDefinitionen = kontrollDefinitionen)
            WEQualitaetsdokumentationHinweis()
            WEVorgangslogSignature()
        }
    }
}

@Composable
private fun WEQualitaetsdokumentationTitleRow(auftrag: All) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(12.px)
            marginTop(55.px)
            marginBottom(27.px)
            textAlign("center")
            fontSize(16.px)
            lineHeight(20.px)
        }
    }) {
        Div({ style { fontSize(30.px); lineHeight(36.px); property("font-weight", "700") } }) {
            Text("Qualitätsdokumentation Wareneingang")
        }
        WEProzessHeaderMetaRow(auftrag = auftrag)
    }
}

@Composable
private fun WEQualitaetsdokumentationTiles(auftrag: All, kontrollDefinitionen: List<All>) {
    val palettenTiles = listOf(
        "Paletten unbeschädigt" to weQualitaetExtraValue(auftrag, "mobil.wePalettenUnbeschädigt"),
        "Paletten Fehlmenge" to weQualitaetExtraValue(auftrag, "mobil.wePalettenFehlmenge"),
        "Paletten Bruch" to weQualitaetExtraValue(auftrag, "mobil.wePalettenBruch"),
        "Paletten Überzählig" to weQualitaetExtraValue(auftrag, "mobil.wePalettenÜberzählig")
    )
    val kontrollTiles = kontrollDefinitionen
        .filter { it.weVorgangslogKontrollLabel().isNotBlank() }
        .map { definition ->
            definition.weVorgangslogKontrollLabel() to weVorgangslogKontrollValue(auftrag, definition).ifBlank { "-" }
        }
    Div({
        style {
            display(DisplayStyle.Grid)
            property("grid-template-columns", "repeat(4, 1fr)")
            gap(8.px)
        }
    }) {
        (palettenTiles + kontrollTiles).forEach { (label, value) ->
            WEQualitaetsdokumentationBox(label = label, value = value)
        }
    }
}

@Composable
private fun WEQualitaetsdokumentationHinweis() {
    Div({
        style {
            marginTop(12.px)
            marginBottom(2.px)
            fontSize(12.px)
            lineHeight(16.px)
            color(Color("#333333"))
            textAlign("left")
        }
    }) {
        Text("Die Wareneingangskontrolle umfasst die Prüfung der angelieferten Mengen- und Ladeeinheiten sowie eine grobe Sichtprüfung. Nachgelagerte Mengen-, Artikel- oder Qualitätsabweichungen werden im WE Fehlerprotokoll dokumentiert.")
    }
}
